export default {
    maskBaseUrl: 'https://zamhown.github.io/wear-a-mask/masks/',
    modelBaseUrl: 'https://zamhown.github.io/wear-a-mask/weights/',
    assetsBaseUrl: 'https://zamhown.github.io/wear-a-mask/assets/'
}